import type { DashboardTab } from '../../../config/dashboardTabs';
import { DASHBOARD_TABS } from '../../../config/dashboardTabs';
import styles from '../../dashboard/Dashboard.module.scss';

interface DashboardTabsProps {
  value: DashboardTab;
  onChange: (tab: DashboardTab) => void;
}

export const DashboardTabs = ({ value, onChange }: DashboardTabsProps) => (
  <div className={styles.tabsRow} role="tablist" aria-label="Dashboard sections">
    {DASHBOARD_TABS.map((tab) => {
      const isActive = tab.key === value;
      return (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`${styles.tab} ${isActive ? styles.tabActive : ''}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);
